import Page from './src/components/Page'

export const wrapPageElement = Page
